import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { ConcreteTest } from '../types'
import { HelpMessage } from 'utils/constants'
import { Report } from 'shared'
import CIMSLink from 'components/CIMSLink'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'

export function useColumns(): CIMSColumn<ConcreteTest>[] {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Tests
  const dependencies = useReportURLDependencies()
  return [
    {
      title: 'Test ID',
      render: ({ fieldNumber, globalId }) => (
        <CIMSLink
          tooltip={Report.ConcreteCylinderIASheet.name}
          href={Report.ConcreteCylinderIASheet.toURL({
            globalId,
            ...dependencies,
          })}
          external
        >
          {fieldNumber}
        </CIMSLink>
      ),
      width: 125,
      help: help.TestID,
      sort: {
        with: 'key',
        key: 'fieldNumber',
        default: 'ascend',
      },
    },
    {
      title: 'Percent Air',
      help: help.PercentAir,
      width: 123,
      render: 'percentAir',
    },
    {
      title: 'Slump',
      help: help.Slump,
      width: 94,
      render: 'slump',
    },
    {
      title: 'Air Temp',
      help: help.AirTemp,
      width: 109,
      render: 'airTemp',
    },
    {
      title: 'Concrete Temp',
      help: help.ConcreteTemp,
      width: 149,
      render: 'concreteTemp',
    },
    {
      title: 'Unit Weight',
      help: help.UnitWeight,
      width: 126,
      render: 'unitWeight',
    },
    {
      title: '28 Day Average',
      help: help.Twenty8DayAvg,
      width: 153,
      render: 'average28DayStrength',
    },
    {
      title: 'Notes',
      help: help.Notes,
      width: 347,
      render: 'notes',
    },
  ]
}
